window.addEventListener("DOMContentLoaded", function() {
    let imgs = document.querySelectorAll('.img-wrapper img')
    let container, allDetails
    for (let img of imgs) {
        img.addEventListener('click',  function(e) {
            container = e.target.closest('.verleih-sportarten__item')
            container.querySelector('.accordion-plus').classList.toggle('show-accordion-plus')
            allDetails = container.querySelectorAll('details')
            for (d of allDetails){
            	d.setAttribute('open', true)
            }
        });
    }
});